import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import registry, * as fromRegistry from 'registry/reducers/registry-reducer'
import user, * as fromUser from 'registry/reducers/user-reducer'
import onboarding, * as fromOnboarding from './onboarding-reducer'

export default combineReducers({
  form,
  onboarding,
  registry,
  user,
})

export const getOnboarding = (state) => state.onboarding
export const getRegistry = (state) => state.registry
export const getUser = (state) => state.user

// Onboarding
export const getUserFields = (state) =>
  fromOnboarding.getUserFields(getOnboarding(state))
export const getIsHavingMultipleBabies = (state) =>
  fromOnboarding.getIsHavingMultipleBabies(getOnboarding(state))
export const getSentiment = (state) =>
  fromOnboarding.getSentiment(getOnboarding(state))
export const getUserWantsToAddItemsFromAnyStore = (state) =>
  fromOnboarding.getUserWantsToAddItemsFromAnyStore(getOnboarding(state))
export const getInitialRegItems = (state) =>
  fromOnboarding.getInitialRegItems(getOnboarding(state))
export const getApprovedProductRecommendations = (state) =>
  fromOnboarding.getApprovedProductRecommendations(getOnboarding(state))

// Registry
export const getArrivalDate = (state) =>
  fromRegistry.getArrivalDate(getRegistry(state))
export const getPartner = (state) => fromRegistry.getPartner(getRegistry(state))
export const getPartnerEmail = (state) =>
  fromRegistry.getPartnerEmail(getRegistry(state))
export const getPartnerFirstName = (state) =>
  fromRegistry.getPartnerFirstName(getRegistry(state))
export const getPartnerLastName = (state) =>
  fromRegistry.getPartnerLastName(getRegistry(state))
export const getRegistryUrlSlug = (state) =>
  fromRegistry.getRegistryUrlSlug(getRegistry(state))

// User
export const getUserEmail = (state) => fromUser.getEmail(getUser(state))
export const getUserFullName = (state) => fromUser.getFullName(getUser(state))
export const getUserId = (state) => fromUser.getId(getUser(state))
